module.exports = __webpack_public_path__ + "static/apps-ef0bce369ebdca4a4fc26ad741581b8d.png";